import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7174a8b0")
const _hoisted_1 = { class: "searchDiv" }
const _hoisted_2 = { class: "contentDiv" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"color":"#f50"} }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, " 暂无可关联的课件 ", -1)
const _hoisted_7 = { class: "footer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 确定 ")
_popScopeId()

import { message } from 'ant-design-vue'
import { reactive, onBeforeMount, computed, watch, ref } from 'vue'
import SearchBar from '@/components/common/SearchBar'
import { useRoute } from 'vue-router'
import {
  getCoursewareInfo,
  getCoursewareVersionInfo
} from '@/services/courseware'
import * as service from '@/views/mine-coursewares/service'
import { debounce } from '@/utils/common'


export default {
  props: {
  relateCoursewareIds: Array,
  relateCoursewares: Array,
  coursewareId: {
    type: Number,
    default: 0
  },
  relateType: String,
  visible: {
    type: Boolean,
    default: () => {
      return false
    }
  },
  coursewareType: {
    type: String,
    default: () => {
      return 'official'
    }
  }
},
  emits: ['ok', 'onCancel', 'onOk'],
  setup(__props, { emit }) {

const props = __props
const treeData = ref([
  { title: '我的课件', checkable: false, key: 0, children: [] }
])
const allData = ref([])
const expandedKeys = ref([0])
const selectedKeys = ref([])
const checkedKeys = ref([])
const checkedIds = ref([])
const checkedItems = ref([])

const autoExpandParent = ref(true)
const dataList = []

const modal = ref()

const route = useRoute()





const pageState = reactive({
  action: route.params.action,
  type: route.params.type,
  relateType: props.relateType,
  status_code: -1,
  id: props.coursewareId === 0 ? parseInt(route.params.id) : props.coursewareId,
  current: {
    relate_courseware_ids: []
  }
})
const searchValue = ref('')
const relateState = reactive({
  name: '',
  coursewareType: props.coursewareType,
  collected_ids: [],
  nameList: []
})

const onExpand = (keys) => {
  expandedKeys.value = keys
  autoExpandParent.value = false
}
const generateList = data => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i]
    const key = node.key
    dataList.push({
      key,
      title: node.title
    })
    if (node.children) {
      generateList(node.children)
    }
  }
}

const getParentKey = (key, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some(item => item.key === key)) {
        parentKey = node.key
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children)
      }
    }
  }
  return parentKey
}

const handleAutoExpand = debounce((value) => {
  if (value === '' || !value) {
    expandedKeys.value = [0]
    autoExpandParent.value = true
    return
  }
  const expanded = dataList
    .map(item => {
      if (item.title.indexOf(value) > -1) {
        return getParentKey(item.key, treeData.value)
      }
      return null
    })
    .filter((item, i, self) => item && self.indexOf(item) === i)
  if (expanded.length === 0) {
    expanded.push(0)
  }
  expandedKeys.value = expanded
  autoExpandParent.value = true
}, 500)
watch(searchValue, value => {
  handleAutoExpand(value)
})

watch(() => props.relateCoursewareIds, async (val) => {
  pageState.current.relate_courseware_ids = props.relateCoursewareIds
  relateState.collected_ids = val
  checkedKeys.value = allData.value.filter(i => val.includes(i.courseware?.id)).map(i => i.id)
}, {
  immediate: true,
  deep: true
})

const visibleValue = computed(() => props.visible)

const handleCancel = () => {
  emit('onCancel')
}

const handleFilter = () => {
  console.log(searchValue)
}
// 构造菜单树数据
const getTreeData = (parent_id, menus) =>
  menus
    .filter(item => (item.parent_id ?? 0) === parent_id)
    .map(item => {
      if (menus.filter(menu => (menu.parent_id ?? 0) === item.id).length === 0) {
        return { title: item.name, key: item.id, checkable: item.type !== 0 }
      }
      return {
        checkable: item.type !== 0,
        title: item.name,
        key: item.id,
        children: getTreeData(item.id, menus)
      }
    })

const getRelateData = (items, pagination) => {
  treeData.value = [{
    checkable: false,
    title: '我的课件',
    key: 0,
    children: getTreeData(0, items)
  }]
  generateList(treeData.value)
}

const handleSubmit = async () => {
  // 编辑/新建教案或说课的情况
  if (pageState.relateType === 'ppt') {
    checkedItems.value = allData.value.filter(i => checkedKeys.value.includes(i.id))
    checkedIds.value = checkedItems.value.map(i => i.courseware?.id)
    localStorage.setItem('relate_ppts', JSON.stringify(checkedItems.value))
    emit('ok')
  } else {
    // 编辑PPT的情况
    if (relateState.coursewareType === 'teacher') {
      checkedItems.value = allData.value.filter(i => checkedKeys.value.includes(i.id))
      checkedIds.value = checkedItems.value.map(i => i.courseware?.id)
      let nowRelateCoursewareIds = []
      const relate_plan_ids = sessionStorage.getItem('relate_plan_ids')
      const relate_speak_ids = sessionStorage.getItem('relate_speak_ids')
      const planIds = JSON.parse(relate_plan_ids === null ? '' : relate_plan_ids)
      const speakIds = JSON.parse(relate_speak_ids === null ? '' : relate_speak_ids)
      if (pageState.relateType === 'lesson') {
        nowRelateCoursewareIds = [...new Set([...checkedIds.value, ...speakIds])]
      } else {
        nowRelateCoursewareIds = [...new Set([...checkedIds.value, ...planIds])]
      }
      await service.editTeacherCourseware(props.coursewareId, { relate_courseware_ids: nowRelateCoursewareIds })
      if (pageState.relateType === 'lesson') {
        sessionStorage.setItem('relate_plan_ids', JSON.stringify(checkedIds.value))
      } else {
        sessionStorage.setItem('relate_speak_ids', JSON.stringify(checkedIds.value))
      }
      pageState.status_code = 0
      message.success('关联成功')
      emit('onOk', { data: checkedItems.value, relateType: pageState.relateType })
    }
    // 新建PPT/编辑接口请求成功后的情况
    if (pageState.relateType === 'lesson') {
      const collectRelateInfo = relateState.nameList.filter(items => {
        return relateState.collected_ids.indexOf(items.value) !== -1
      })
      const relate_lessons = collectRelateInfo.map(({ value, label, type }) => ({ id: value, name: label, type: type }))
      sessionStorage.setItem('relate_lessons', JSON.stringify(relate_lessons))
    } else if (pageState.relateType === 'speak') {
      const collectRelateInfo = relateState.nameList.filter(items => {
        return relateState.collected_ids.indexOf(items.value) !== -1
      })
      const relate_speaks = collectRelateInfo.map(({ value, label, type }) => ({ id: value, name: label, type: type }))
      sessionStorage.setItem('relate_speaks', JSON.stringify(relate_speaks))
    }
    // 整理relate_courseware避免ppt切换tab时qiankun事件遍历的relate_courseware存在null
    const relate_lessons = JSON.parse(sessionStorage.getItem('relate_lessons'))
    const relate_speaks = JSON.parse(sessionStorage.getItem('relate_speaks'))
    let relate_coursewares
    if (!relate_lessons) {
      relate_coursewares = relate_speaks
    } else if (!relate_speaks) {
      relate_coursewares = relate_lessons
    } else if (relate_lessons && relate_speaks) {
      relate_coursewares = relate_lessons.concat(relate_speaks)
    }
    sessionStorage.setItem('relate_coursewares', JSON.stringify(relate_coursewares))
    // 回调数据给ppt-editor
    if (!props.coursewareId) {
      if (relateState.coursewareType === 'official') {
        emit('onOk', { relate_coursewares: relate_coursewares, coursewareSource: 'official', status_code: pageState.status_code, coursewareId: props.coursewareId })
      } else if (relateState.coursewareType === 'teacher') {
        emit('onOk', { relate_coursewares: relate_coursewares, coursewareSource: 'teacher', status_code: pageState.status_code, coursewareId: props.coursewareId })
      }
    }
  }
  emit('onCancel')
}

const getInfo = async () => {
  if (pageState.action === 'version-detail') {
    pageState.id = (await getCoursewareVersionInfo(pageState.id)).courseware_id
  }
  if (props.coursewareId) {
    pageState.id = props.coursewareId
  }
  if (!pageState.id) {
    return
  }
  if (relateState.coursewareType === 'teacher') {
    pageState.current = await service.getTeacherCourseware(pageState.id)
    pageState.current.relate_courseware_ids = pageState.current.relate_coursewares.map(item => item.id)
    checkedKeys.value = allData.value.filter(i => pageState.current.relate_courseware_ids.includes(i.courseware?.id)).map(i => i.id)
  } else if (relateState.coursewareType === 'official') {
    pageState.current = await getCoursewareInfo(pageState.id)
    pageState.current.relate_courseware_ids = pageState.current.relate_coursewares.map(item => item.id)
  }
}

const getList = async (params) => {
  // 当前页面为编辑/新建ppt页面
  if (pageState.relateType === 'lesson') { // 当前需要关联的课件为教案时
    if (relateState.coursewareType === 'teacher') {
      const { items, pagination } = await service.queryTeacherCoursewareList({ per_page: 9999 })
      const data = items.filter(i => i.type === 0 || (i.type === 1 && i.courseware.type === 'plan'))
      allData.value = data
      if (checkedKeys.value === 0) {
        const val = pageState.current.relate_courseware_ids
        checkedKeys.value = allData.value.filter(i => val.includes(i.courseware?.id)).map(i => i.id)
      }
      getRelateData(data, pagination)
    }
  } else if (pageState.relateType === 'speak') { // 当前需要关联的课件为说课时
    if (relateState.coursewareType === 'teacher') {
      const { items, pagination } = await service.queryTeacherCoursewareList({ per_page: 9999 })
      const data = items.filter(i => i.type === 0 || (i.type === 1 && i.courseware.type === 'speak'))
      allData.value = data
      if (checkedKeys.value === 0) {
        const val = pageState.current.relate_courseware_ids
        checkedKeys.value = allData.value.filter(i => val.includes(i.courseware?.id)).map(i => i.id)
      }
      getRelateData(data, pagination)
    }
  } else if (pageState.relateType === 'ppt') { // 当前需要关联的课件为说课时
    if (relateState.coursewareType === 'teacher') {
      const { items, pagination } = await service.queryTeacherCoursewareList({ per_page: 9999 })
      const data = items.filter(i => i.type === 0 || (i.type === 1 && i.courseware.type === 'ppt'))
      allData.value = data
      if (checkedKeys.value === 0) {
        const val = pageState.current.relate_courseware_ids
        checkedKeys.value = allData.value.filter(i => val.includes(i.courseware?.id)).map(i => i.id)
      }
      getRelateData(data, pagination)
    }
  }
}

onBeforeMount(async () => {
  await getList()
  await getInfo()
  pageState.current.relate_courseware_ids = props.relateCoursewareIds
  relateState.collected_ids = pageState.current.relate_courseware_ids
  if (pageState.current.relate_courseware_ids.length > 0) {
    checkedKeys.value = allData.value.filter(i => pageState.current.relate_courseware_ids.includes(i.courseware?.id)).map(i => i.id)
  }
})

return (_ctx, _cache) => {
  const _component_a_tree = _resolveComponent("a-tree")
  const _component_a_empty = _resolveComponent("a-empty")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock("div", {
    ref: (_value, _refs) => {
      _refs['modal'] = _value
      modal.value = _value
    }
  }, [
    _createVNode(_component_a_modal, {
      getContainer: () => modal.value,
      footer: null,
      width: "550px",
      visible: _unref(visibleValue),
      onCancel: handleCancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(SearchBar), {
            value: searchValue.value,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => (searchValue.value = $event)),
            "on-search": handleFilter,
            "on-change": handleFilter
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          ((treeData.value.length !== 0))
            ? (_openBlock(), _createBlock(_component_a_tree, {
                key: 0,
                checkable: "",
                "tree-data": treeData.value,
                expandedKeys: expandedKeys.value,
                "onUpdate:expandedKeys": _cache[1] || (_cache[1] = $event => (expandedKeys.value = $event)),
                selectedKeys: selectedKeys.value,
                "onUpdate:selectedKeys": _cache[2] || (_cache[2] = $event => (selectedKeys.value = $event)),
                checkedKeys: checkedKeys.value,
                "onUpdate:checkedKeys": _cache[3] || (_cache[3] = $event => (checkedKeys.value = $event)),
                autoExpandParent: autoExpandParent.value,
                onOnExpand: onExpand
              }, {
                title: _withCtx(({ title }) => [
                  (title.indexOf(searchValue.value) > -1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                        _createTextVNode(_toDisplayString(title.substr(0, title.indexOf(searchValue.value))) + " ", 1),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(searchValue.value), 1),
                        _createTextVNode(" " + _toDisplayString(title.substr(title.indexOf(searchValue.value) + searchValue.value.length)), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(title), 1))
                ]),
                _: 1
              }, 8, ["tree-data", "expandedKeys", "selectedKeys", "checkedKeys", "autoExpandParent"]))
            : (_openBlock(), _createBlock(_component_a_empty, { key: 1 }, {
                description: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_button, {
            type: "primary",
            class: "submitBtn",
            onClick: handleSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["getContainer", "visible"])
  ], 512))
}
}

}